/**
 * Calculates image size for previously up-scaled or down-scaled texture
 *
 * @param {number} scale when scale is equal to 1 it will not be applied and this function will return null
 * @param {Object} texture Lightning texture
 * @returns {?Object} size containing "w" and "h" properties, or null if scale is equal to 1
 */
export const getScaledTextureSize = (texture, scale = 1) => {
  if (scale !== 1 && texture._source) {
    const { w, h } = texture._source;

    return {
      w: Math.round(w / scale),
      h: Math.round(h / scale),
    };
  }

  return null;
};
